export default function FormattedAddress({ address, singleLine }) {
  if (!address) {
    return null;
  }

  if (singleLine) {
    return <span>{formatAddress(address)}</span>;
  }

  return (
    <div className="flex-col">
      <p className="!mb-0">{address.street}</p>

      {address.street2 && <p className="!mb-0">{address.street2}</p>}

      <p className="!mb-0">
        {address.city}, {address.state} {address.postalCode}
      </p>
    </div>
  );
}

export function formatAddress(address) {
  return [address?.street, address?.street2, address?.city, address?.state, address?.postalCode]
    .filter(Boolean)
    .join(', ');
}
